export const addonsModalBodyStyles = {
  maxHeight: "352px",
};
